@if (orderId(); as orderId) {
  <pfx-order-details-sidebar
    [orderId]="orderId"
    [visible]="viewOrder()"
    (visibleChange)="handleSidebarVisibleChanged($event)"
  ></pfx-order-details-sidebar>
}
